var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgPricing = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.332,
    height: 16,
    viewBox: "0 0 12.332 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "rocket_FILL0_wght300_GRAD-25_opsz24",
    d: "M193.7-843.041l2.012-.818q-.251-.757-.442-1.537a13.214,13.214,0,0,1-.285-1.582l-1.169.788a.282.282,0,0,0-.087.095.247.247,0,0,0-.029.12Zm3.249-.951h3.43a14.176,14.176,0,0,0,.665-2.381,13.687,13.687,0,0,0,.238-2.558,10.432,10.432,0,0,0-.661-3.725,8.823,8.823,0,0,0-1.958-3.073,8.8,8.8,0,0,0-1.956,3.073,10.461,10.461,0,0,0-.658,3.725,13.8,13.8,0,0,0,.236,2.558A14.045,14.045,0,0,0,196.951-843.992Zm1.715-4.589a1.4,1.4,0,0,1-1.032-.424,1.4,1.4,0,0,1-.424-1.032,1.411,1.411,0,0,1,.424-1.034,1.4,1.4,0,0,1,1.032-.426,1.407,1.407,0,0,1,1.034.426,1.407,1.407,0,0,1,.426,1.034A1.4,1.4,0,0,1,199.7-849,1.411,1.411,0,0,1,198.666-848.581Zm4.968,5.54v-2.927a.257.257,0,0,0-.031-.124.306.306,0,0,0-.085-.1l-1.169-.788a14.886,14.886,0,0,1-.31,1.674q-.211.872-.417,1.46Zm-4.968-14.226a8.949,8.949,0,0,1,2.826,3.6,11.946,11.946,0,0,1,.992,4.913q0,.105,0,.211t-.009.222l1.7,1.136a1.482,1.482,0,0,1,.486.531,1.408,1.408,0,0,1,.179.686v4.7l-3.786-1.525H196.28l-3.778,1.525v-4.709a1.448,1.448,0,0,1,.172-.686,1.43,1.43,0,0,1,.48-.531l1.7-1.136q0-.108,0-.214t0-.211a11.968,11.968,0,0,1,.99-4.913A8.933,8.933,0,0,1,198.666-857.267Z",
    transform: "translate(-192.502 857.267)",
    fill: "#fff"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPricing, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pricing.71e0b352.svg";
export { ForwardRef as ReactComponent };